import find from 'lodash/find';
import helpers from 'app/app-helpers';
import { setActiveTab } from 'utils/actions/active-tab/active-tab.actions';
import { fetchLotteryContacts } from 'contact/actions/contact.actions';
import { fetchInquiryReasonsDictionary } from 'app/actions/dictionaries/inquiry-reasons-dictionary.actions';
import { checkAccess } from 'app/actions/app.actions';
import * as api from '../../resources/contact.api';
import contactUsTemplate from './contact-us.html';
import tabs from './tabs';

const MAX_MESSAGE_LENGTH = 512;
const MAX_INQUIRY_REASON_LENGTH = 255;
const SEND_CONTACT_PERMISSION = 'contact.sendContact';

const mapStateToThisContactUsBase = ({ session, config, retailerDetails, dictionary, contact, ui }) => {
  const retailerName = retailerDetails.businessName;
  const { phoneMask, phoneLength, maxFirstNameLength, maxLastNameLength, maxEmailLength } = config;
  const { loggedIn, locale, retailer, firstName = '', lastName = '', role = '', contactPhone = '', emailAddress = '' } = session;
  const { retailerDisplayNumber, retailerType } = retailer;
  const { inquiryReasons } = dictionary;
  const { lottery, inquiry } = contact;
  const { activeTab } = ui;
  const { CONTACT_THE_LOTTERY, LOTTERY_CONTACT_INFO } = tabs;

  return {
    loggedIn,
    locale,
    phoneMask,
    phoneLength,
    maxFirstNameLength,
    maxLastNameLength,
    maxEmailLength,
    retailerDisplayNumber,
    retailerType,
    firstName,
    lastName,
    role,
    contactPhone,
    emailAddress,
    retailerName,
    inquiryReasons,
    lottery,
    inquiry,
    activeTab,
    CONTACT_THE_LOTTERY,
    LOTTERY_CONTACT_INFO,
  };
};
const mapDispatchToThis = {
  fetchLotteryContacts,
  fetchInquiryReasonsDictionary,
  setActiveTab,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'gettextCatalog', '$stateParams', 'Notifications')
class ContactUsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThisContactUsBase, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.contactTheLotteryTabActive = this.checkAccess(SEND_CONTACT_PERMISSION);
    await Promise.all([this.fetchLotteryContacts(), this.fetchInquiryReasonsDictionary()]);
    this.maxMessageLength = MAX_MESSAGE_LENGTH;
    this.maxInquiryReason = MAX_INQUIRY_REASON_LENGTH;
    this.initInquiryReasonsList();
    this.initActiveTab();
    this.initContactUsModel();
  }

  $onDestroy() {
    this.setActiveTab('', 'activeTab');
    this.unsubscribe();
  }

  initInquiryReasonsList() {
    this.inquiryReasonsList = this.loggedIn
      ? this.inquiryReasons.filter(({ availableForUser }) => availableForUser)
      : this.inquiryReasons.filter(({ availableForAnonymous }) => availableForAnonymous);
  }

  initActiveTab() {
    if (this.$stateParams.tabId) {
      this.setActiveTab(this.$stateParams.tabId, 'activeTab');
    } else {
      this.setActiveTab(this.LOTTERY_CONTACT_INFO, 'activeTab');
    }
  }

  initContactUsModel() {
    this.contactUsModel = {
      firstName: this.firstName,
      lastName: this.lastName,
      retailerNumber: this.retailerDisplayNumber,
      retailerName: this.retailerName,
      outletType: this.retailerType,
      roleType: this.role,
      email: this.emailAddress,
      phone: this.contactPhone,
      inquiryReasonKey: this.$stateParams.inquiryReason || '',
    };
  }

  submit() {
    if (this.pendingRequest) {
      return;
    }

    this.contactUsForm.$setSubmitted();
    if (this.contactUsForm.$invalid) {
      return;
    }

    this.pendingRequest = true;
    this.contactUsModel.locale = this.locale;

    api
      .sendContact(this.contactUsModel, this.loggedIn)
      .then(
        () =>
          this.Notifications.showAlert(
            this.gettextCatalog.getString('Success!'),
            this.gettextCatalog.getString(
              'Thank you for contacting us. We will direct your inquiry to the right person on your Lottery team, who will respond to you as soon as possible.'
            )
          ).result
      )
      .then(() => {
        this.pendingRequest = false;
        if (this.loggedIn) {
          helpers.redirectToFirstPageFromMenu({ $state: this.$state });
        } else {
          helpers.redirectToHome({ $state: this.$state });
        }
      });
  }

  customReasonChosen() {
    if (!this.contactUsModel) {
      return false;
    }
    const chosenReasonId = this.contactUsModel.inquiryReasonKey;
    if (chosenReasonId) {
      const item = find(this.inquiryReasons, ['reasonKey', chosenReasonId]);
      return item && item.custom;
    }
    return false;
  }
}

export default class ContactUsComponent {
  constructor() {
    this.template = contactUsTemplate;
    this.controller = ContactUsController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/contact/components/contact-us/contact-us-component.js